export default __webpack_public_path__ + "static/media/Samples.1b49adbe.svg";